import { Link } from "react-router-dom";
import { mediaList } from "@/mocks/movies";

const stats = [
  { value: `${mediaList.length}`, label: "精选影视" },
  { value: "3", label: "内容分类" },
  { value: "6", label: "覆盖地区" },
  { value: "4", label: "年份跨度" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16" aria-label="网站简介">
      <div className="grid items-start gap-10 lg:grid-cols-[1fr_360px] lg:gap-16">
        <div>
          <p className="text-[11px] uppercase tracking-[0.3em] text-primary-600">About Mitao 33</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[30px]">
            一个把影视资料整理清楚的站点
          </h2>
          <p className="mt-5 max-w-2xl text-sm leading-[1.9] text-foreground-600">
            蜜桃33 面向普通观众与影视爱好者，覆盖电影、电视剧与综艺三类内容。每部作品都配有封面、类型标签、主创信息与完整剧情介绍，你可以按类型、地区、年份多选筛选，也可以直接搜索片名。
          </p>
          <p className="mt-3 max-w-2xl text-sm leading-[1.9] text-foreground-600">
            我们不追求把所有内容堆在首页，而是希望你在三步之内找到今晚想看的那一部——先选形式，再收窄条件，最后在详情页确认它是不是你想看的故事。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/about"
              className="inline-flex h-10 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解站点与服务
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/search"
              className="inline-flex h-10 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-search-line" />
              先去搜索试试
            </Link>
          </div>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <div className="grid grid-cols-2 gap-x-4 gap-y-6">
            {stats.map((stat) => (
              <div key={stat.label}>
                <p className="font-heading text-3xl font-bold text-primary-600">{stat.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 rounded-md bg-accent-50 p-4">
            <p className="flex items-center gap-1.5 text-xs font-medium text-accent-800">
              <i className="ri-information-line" />
              演示状态说明
            </p>
            <p className="mt-2 text-[11px] leading-relaxed text-foreground-600">
              站内影视资料、评分与主创均为虚构示例，暂未接入真实片源，不提供在线播放。所有“观看”入口均会提示演示状态。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}